module.exports = __webpack_public_path__ + "media/images/arrow-right-a2e47e0be1acea4b464359b49744c5c9.svg";